import { InvoicesRepository } from '../repositories/invoices.repository'
import {
    CompleteDataWithServicesPayloadT,
    InvoicesDownloadExcelPayloadT,
    InvoicesDownloadExcelResponseT,
    InvoicesGetListParamsT,
    InvoicesGetListResponseT,
    InvoicesGetListShortParamsT,
    InvoicesGetQuantityParamsT,
    InvoicesGetQuantityResponseT,
    InvoicesGetStatusesResponse,
    InvoicesInternationalGetListParamsT,
    InvoicesWithServicesDownloadExcelPayloadT,
    InvoicesWithServicesDownloadExcelResponseT,
    InvoicesWithServicesListResponseT,
    UpdateInvoicePayloadT,
    UplodaFilesResponseT,
    WithServicesListParamsT,
} from '../types/invoices.types'

const invoicesRepository = new InvoicesRepository()

export class InvoicesService {
    async getList(
        params?: InvoicesGetListParamsT | InvoicesGetListShortParamsT
    ): Promise<InvoicesGetListResponseT> {
        const response = await invoicesRepository.getList(params)
        return response.data
    }

    async getInvoiceStatuses(): Promise<InvoicesGetStatusesResponse> {
        const response = await invoicesRepository.getInvoiceStatuses()
        return response.data
    }

    async getListInternational(
        params: InvoicesInternationalGetListParamsT
    ): Promise<InvoicesGetListResponseT> {
        const response = await invoicesRepository.getListInternational(params)
        return response.data
    }

    async getQuantity(params?: InvoicesGetQuantityParamsT): Promise<InvoicesGetQuantityResponseT> {
        const response = await invoicesRepository.getQuantity(params)
        return response.data
    }

    async updateInvoice(invoice_id: number, payload: UpdateInvoicePayloadT): Promise<void> {
        const response = await invoicesRepository.updateInvoice(invoice_id, payload)
        return response.data
    }

    async importCashSum(form_data: FormData): Promise<void> {
        const response = await invoicesRepository.importCashSum(form_data)
        return response.data
    }

    async importInvoices(form_data: FormData): Promise<void> {
        const response = await invoicesRepository.importInvoices(form_data)
        return response.data
    }

    async importDeleteAdditional(form_data: FormData): Promise<void> {
        const response = await invoicesRepository.importDeleteAdditional(form_data)
        return response.data
    }

    async importDeclaredPrice(form_data: FormData): Promise<void> {
        const response = await invoicesRepository.importDeclaredPrice(form_data)
        return response.data
    }

    async withServicesList(
        params: WithServicesListParamsT
    ): Promise<InvoicesWithServicesListResponseT> {
        const response = await invoicesRepository.withServicesList(params)
        return response.data
    }

    async enterDataWithServices(
        invoice_id: number,
        additionalServices: CompleteDataWithServicesPayloadT[]
    ): Promise<void> {
        const response = await invoicesRepository.enterDataWithServices(
            invoice_id,
            additionalServices
        )
        return response.data
    }

    async exportExcel(
        params: InvoicesDownloadExcelPayloadT
    ): Promise<InvoicesDownloadExcelResponseT> {
        const response = await invoicesRepository.exportExcel(params)
        return response.data
    }

    async exportKaspiReport(
        params: InvoicesDownloadExcelPayloadT
    ): Promise<InvoicesDownloadExcelResponseT> {
        const response = await invoicesRepository.exportKaspiReport(params)
        return response.data
    }

    async exportExcelWithServices(
        params: InvoicesWithServicesDownloadExcelPayloadT
    ): Promise<InvoicesWithServicesDownloadExcelResponseT> {
        const response = await invoicesRepository.exportExcelWithServices(params)
        return response.data
    }

    async deleteService(id: number): Promise<void> {
        const response = await invoicesRepository.deleteService(id)
        return response.data
    }

    async deleteFile(id: number): Promise<void> {
        const response = await invoicesRepository.deleteFile(id)
        return response.data
    }

    async deleteStatus(id: number): Promise<void> {
        const response = await invoicesRepository.deleteStatus(id)
        return response.data
    }

    async uploadFiles(form_data: FormData): Promise<UplodaFilesResponseT> {
        const response = await invoicesRepository.uploadFiles(form_data)
        return response.data
    }
}
